import * as actionTypes from '../actions/actionTypes'

const initialState = {
  pagination: { total: 0, to: 0, lastPage: 1, from: 0, currentPage: 1, perPage: 10 },
  records: [],
  loading: false,
  filterLoading: false,
  success: false,
  selectedRecord: null,
  company: [],
  appraisalYear: [],
  resultType: [],
  filterForm: [],
  loadingStates: []
}

const fetchFormStart = (state, action) => {
  return { ...state, loading: true, loadingStates: [...state.loadingStates, 'record'] }
}

const fetchFormSuccess = (state, action) => {
  let { records } = action
  records = records.map(res => {
    let data = res
    return {
      ...data,
      company_name: data?.company?.company_name
    }
  })
  return {
    ...state,
    loading: false,
    pagination: action.pagination,
    loadingStates: state.loadingStates.filter(item => item !== 'record'),
    records: records
  }
}

const fetchFormFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    loadingStates: state.loadingStates.filter(item => item !== 'record'),
    errorMessage: action.errorMessage
  }
}

const fetchFormByIdSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    selectedRecord: action.recordData,
    loadingStates: state.loadingStates.filter(item => item !== 'record')
  }
}

const clearSelectedFormRecord = (state, action) => {
  return {
    ...state,
    selectedRecord: null,
    success: false
  }
}

const createFormStart = (state, action) => {
  return { ...state, loading: true }
}

const createFormSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const createFormFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const updateFormStart = (state, action) => {
  return { ...state, loading: true }
}

const updateFormSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const updateFormFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const deleteFormStart = (state, action) => {
  return { ...state, loading: true }
}

const deleteFormSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const deleteFormFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const fetchCompanyStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchCompanySuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    company: action.data
  }
}

const fetchCompanyFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.errorMessage
  }
}

const fetchAppraisalYearStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchAppraisalYearSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    appraisalYear: action.data
  }
}

const fetchAppraisalYearFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.errorMessage
  }
}

const fetchResultTypeStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchResultTypeSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    resultType: action.data
  }
}

const fetchResultTypeFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.errorMessage
  }
}

const fetchFilterFormStart = (state, action) => {
  return { ...state, filterLoading: true }
}

const fetchFilterFormSuccess = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    filterForm: action.data
  }
}

const fetchFilterFormFailed = (state, action) => {
  return {
    ...state,
    filterLoading: false
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_FORM_START:
      return fetchFormStart(state, action)
    case actionTypes.FETCH_FORM_SUCCESS:
      return fetchFormSuccess(state, action)
    case actionTypes.FETCH_FORM_BY_ID_SUCCESS:
      return fetchFormByIdSuccess(state, action)
    case actionTypes.FETCH_FORM_FAILED:
      return fetchFormFailed(state, action)
    case actionTypes.CLEAR_SELECTED_FORM_RECORD:
      return clearSelectedFormRecord(state, action)
    case actionTypes.CREATE_FORM_START:
      return createFormStart(state, action)
    case actionTypes.CREATE_FORM_SUCCESS:
      return createFormSuccess(state, action)
    case actionTypes.CREATE_FORM_FAILED:
      return createFormFailed(state, action)
    case actionTypes.UPDATE_FORM_START:
      return updateFormStart(state, action)
    case actionTypes.UPDATE_FORM_SUCCESS:
      return updateFormSuccess(state, action)
    case actionTypes.UPDATE_FORM_FAILED:
      return updateFormFailed(state, action)
    case actionTypes.DELETE_FORM_START:
      return deleteFormStart(state, action)
    case actionTypes.DELETE_FORM_SUCCESS:
      return deleteFormSuccess(state, action)
    case actionTypes.DELETE_FORM_FAILED:
      return deleteFormFailed(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_START:
      return fetchCompanyStart(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_SUCCESS:
      return fetchCompanySuccess(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_FAILED:
      return fetchCompanyFailed(state, action)
    case actionTypes.FETCH_APPRAISAL_YEAR_OPTIONS_START:
      return fetchAppraisalYearStart(state, action)
    case actionTypes.FETCH_APPRAISAL_YEAR_OPTIONS_SUCCESS:
      return fetchAppraisalYearSuccess(state, action)
    case actionTypes.FETCH_APPRAISAL_YEAR_OPTIONS_FAILED:
      return fetchAppraisalYearFailed(state, action)
    case actionTypes.FETCH_RESULT_TYPE_OPTIONS_START:
      return fetchResultTypeStart(state, action)
    case actionTypes.FETCH_RESULT_TYPE_OPTIONS_SUCCESS:
      return fetchResultTypeSuccess(state, action)
    case actionTypes.FETCH_RESULT_TYPE_OPTIONS_FAILED:
      return fetchResultTypeFailed(state, action)
    case actionTypes.FETCH_FORM_OPTIONS_START:
      return fetchFilterFormStart(state, action)
    case actionTypes.FETCH_FORM_OPTIONS_SUCCESS:
      return fetchFilterFormSuccess(state, action)
    case actionTypes.FETCH_FORM_OPTIONS_FAILED:
      return fetchFilterFormFailed(state, action)
    case actionTypes.SIGNOUT_SUCCESS:
    case actionTypes.SIGNOUT_FAILED:
      return { ...initialState }
    default:
      return state
  }
}

export default reducer
